<template>
  <div class="modelBoxss" :style="backgroundStyle">
    <!-- 通过props控制标题区域的显示 -->
    <div v-if="showTitle" class="rn-section-gap text-center color-white">
      <div v-if="showMainTitle" class="fs-1 w-700">{{ mainTitle }}</div>
      <div v-if="showSubTitle" class="fs-3">{{ subTitle }}</div>
    </div>
    <div v-if="windowWidth > 767">
      <div class="bottom-list container" v-if="val == '1' || val == '5' || val == '7'">
        <div class="col-6 mt-20" v-for="(item, index) in modelBox[val - 1]" :key="index">
          <div class="moreBox moreBox-one" :id="getUniqueId(index)" @mouseover="titleChange(index)">
            <img class="moreBoxImg3" src="@/assets/images/portfolio/eec/white.png" alt="" />
            <img class="moreBoxImg2" :src="item.img" alt="" />
            <div class="moreBoxContent">
              <h5 class="fs-3">{{ item.title1 }}</h5>
              <div class="text">{{ item.title2 }}</div>
              <button v-if="showButton" class="btn color-white" @click="btns(index)">{{ buttonText }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-list container" v-if="val == '2'">
        <div class="col-4 mt-20" v-for="(item, index) in modelBox[val - 1]" :key="index">
          <div class="moreBox moreBox-one" :id="getUniqueId('0' + index)" @mouseover="titleChange(index)">
            <img class="moreBoxImg3" src="@/assets/images/portfolio/eec/two.png" alt="" />
            <img class="moreBoxImg2" :src="item.img" alt="" />
            <div class="moreBoxContent">
              <h5 class="fs-3">{{ item.title1 }}</h5>
              
			  <div v-if="item.contionLIst && item.contionLIst.length">
				   <div class="text textcontlist"  v-for="(cont,conin) in item.contionLIst">{{ cont }}</div>
			  </div>
			  <div class="text" v-else>{{ item.title2 }}</div>
              <!-- 通过props控制按钮显示 -->
              <button v-if="showButton" class="btn color-white" @click="btns(index)">{{ buttonText }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-list container" v-if="val == '3' || val == '4'">
        <div class="col-4 mt-20" v-for="(item, index) in modelBox[val - 1]" :key="index">
          <div class="moreBox moreBox-one" :id="'00' + index" @mouseover="titleChange(index)">
            <img class="moreBoxImg3" src="@/assets/images/portfolio/eec/three.png" alt="" />
            <img class="moreBoxImg2" :src="item.img" alt="" />
            <div class="moreBoxContent">
              <h5 class="fs-3">{{ item.title1 }}</h5>
              <div class="text">{{ item.title2 }}</div>
              <!-- 通过props控制按钮显示 -->
              <button v-if="showButton" class="btn color-white" @click="btns(index)">{{ buttonText }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="model2 container" v-if="val == '6'">
        <div class="left-img">
          <img src="@/assets/images/portfolio/eec/one.png" alt="" />
        </div>
        <div class="right-text">
          <div class="text">
            <div class="fs-1 w-700">全面预算管理云</div>
            <p>
              全面预算管理分为预算编制、预算执行、数据分析、预算综合预测四个模块，通过系统为企业资源配置、管理协调、全员参与、战略支持自我控制提供数据保障；通过数据分析找出问题点，提质降本，合理分配资源。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-list" v-else>
      <swiper class="mySwipes" :options="swiperOption1" v-if="val == '1' || val == '5' || val == '7'">
        <swiper-slide v-for="(item, index) in modelBox[val - 1]" :key="index">
          <div class="moreBox hoverClass1 moreBox-one">
            <img class="moreBoxImg3" src="@/assets/images/portfolio/eec/white.png" alt="" />
            <img class="moreBoxImg2" :src="item.img" alt="" />
            <div class="moreBoxContent">
              <h5 class="fs-3">{{ item.title1 }}</h5>
              <div class="text">{{ item.title2 }}</div>
              <!-- 通过props控制按钮显示 -->
              <button v-if="showButton" class="btn color-white" @click="btnsMove(index)">{{ buttonText }}</button>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <swiper class="mySwipes" :options="swiperOption1" v-if="val == '2'">
        <swiper-slide v-for="(item, index) in modelBox[val - 1]" :key="index">
          <div class="moreBox hoverClass1 moreBox-one">
            <img class="moreBoxImg3" src="@/assets/images/portfolio/eec/two.png" alt="" />
            <img class="moreBoxImg2" :src="item.img" alt="" />
            <div class="moreBoxContent">
              <h5 class="fs-3">{{ item.title1 }}</h5>
			  <div v-if="item.contionLIst && item.contionLIst.length">
					<div class="text textcontlist"  v-for="(cont,conin) in item.contionLIst">{{ cont }}</div>
			  </div>
			  <div class="text" v-else>{{ item.title2 }}</div>
              <!-- 通过props控制按钮显示 -->
              <button v-if="showButton" class="btn color-white" @click="btnsMove(index)">{{ buttonText }}</button>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <swiper class="mySwipes" :options="swiperOption1" v-if="val == '3' || val == '4'">
        <swiper-slide v-for="(item, index) in modelBox[val - 1]" :key="index">
          <div class="moreBox hoverClass1 moreBox-one">
            <img class="moreBoxImg3" src="@/assets/images/portfolio/eec/three.png" alt="" />
            <img class="moreBoxImg2" :src="item.img" alt="" />
            <div class="moreBoxContent">
              <h5 class="fs-3">{{ item.title1 }}</h5>
              <div class="text">{{ item.title2 }}</div>
              <!-- 通过props控制按钮显示 -->
              <button v-if="showButton" class="btn color-white" @click="btnsMove(index)">{{ buttonText }}</button>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="model2 container" v-if="val == '6'">
        <div class="left-img">
          <img src="@/assets/images/portfolio/eec/one.png" alt="" />
        </div>
        <div class="right-text">
          <div class="text">
            <div class="fs-1 w-700">全面预算管理云</div>
            <p>
              全面预算管理分为预算编制、预算执行、数据分析、预算综合预测四个模块，通过系统为企业资源配置、管理协调、全员参与、战略支持自我控制提供数据保障；通过数据分析找出问题点，提质降本，合理分配资源。
            </p>
          </div>
        </div>
      </div>
    </div>
    <dislog class="dislog" id="dislog" :leftInd="leftInd" :leftCur="leftCur" :val="val" @tochange="changevalue"
      @toclose="toclose"></dislog>
    <moveEECPage class="moveEECPage" id="moveEECPage" :leftInd="leftInd" :val="val" @toclose="toclose"></moveEECPage>
  </div>
</template>

<script>
import dislog from "@/views/TeamEECPage.vue"
import moveEECPage from "@/views/moveEECPage.vue"
import ModelBox1 from "@/components/common/counter/ModelBox1.vue"
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
  name: "ModelBox",
  components: { dislog, ModelBox1, swiper, swiperSlide, moveEECPage },
  // 在props中添加控制放大效果的属性
  props: {
    val: "",
     uniqueId: {
      type: String,
      default: () => Math.random().toString(36).substr(2, 9)
    },
    modelBox: {
      type: Array,
      default: () => [],
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    showMainTitle: {
      type: Boolean,
      default: true
    },
    showSubTitle: {
      type: Boolean,
      default: true
    },
    mainTitle: {
      type: String,
      default: '产品模块'
    },
    subTitle: {
      type: String,
      default: '合规前移，业财融合，数据驱动，重构优势'
    },
    showButton: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: '查看详情'
    },
    // 新增背景图相关props
    backgroundImage: {
      type: String,
      default: '' // 默认为空，使用CSS中的默认背景
    },
    backgroundSize: {
      type: String,
      default: 'cover'
    },
    backgroundRepeat: {
      type: String,
      default: 'no-repeat'
    },
    backgroundPosition: {
      type: String,
      default: 'center'
    },
    // 新增控制图片放大的props
  enableImageScale: {
    type: Boolean,
    default: true // 默认启用放大效果
  },
  },
  computed: {
    backgroundStyle() {
      if (this.backgroundImage) {
        return {
          backgroundImage: `url(${this.backgroundImage})`,
          backgroundSize: this.backgroundSize,
          backgroundRepeat: this.backgroundRepeat,
          backgroundPosition: this.backgroundPosition
        }
      }
      // 如果没有传入backgroundImage，返回空对象，使用CSS默认样式
      return {}
    }
  },
  data() {
    return {
      leftInd: 0,
      leftCur: 0,
      swiperOption1: {
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
      },
      windowWidth: document.documentElement.clientWidth,
    }
  },
  watch: {
    $route() {
      this.toclose()
    }
  },
  mounted() {
    if (this.windowWidth>767) {
      this.titleChange(0)
    }
  },
  // 修改titleChange方法
  methods: {
    btns(type) {
      document.body.style = "oveflow: hidden;"  // 禁止当前视图上下滚动

      // document.body.style = "oveflow: scroll;" // 允许滚动

      console.log(type, "123")
      this.leftInd = type
      this.leftCur = type
      document.getElementById("dislog").style.display = "inline-block"
      // this.$refs.ModelBox1.openmodal()
    },
    btnsMove(type) {
      this.leftInd = type
      document.getElementById("moveEECPage").style.display = "inline-block"
      let _scrollTop = document.scrollingElement.scrollTop
      document.body.style.position = 'fixed'
      document.body.style.top = -_scrollTop + 'px'
    },
    changevalue(type) {
      console.log(type)
      this.leftInd = type
      this.leftCur = type
    },
    toclose() {
      document.getElementById("dislog").style.display = "none"
      document.getElementById("moveEECPage").style.display = "none"
      document.body.style.position = ''
      document.body.style.top = ''
    },
    getUniqueId(index) {
      return `${this.uniqueId}_${index}`
    },
    titleChange(index) {
      for (let i = 0; i < this.modelBox[this.val - 1].length; i++) {
        let elementId = this.getUniqueId(i)
        if (this.val == '2') {
          elementId = this.getUniqueId('0' + i)
        }
        if (this.val == '3' || this.val == '4') {
          elementId = this.getUniqueId('00' + i)
        }
        
        const element = document.getElementById(elementId)
        if (element) {
          // 移除所有可能的hover类
          if (element.getAttribute("class").indexOf("hoverClass1") != -1) {
            element.classList.remove("hoverClass1")
          }
          if (element.getAttribute("class").indexOf("no-scale-hover") != -1) {
            element.classList.remove("no-scale-hover")
          }
        }
      }
      
      let targetId = this.getUniqueId(index)
      if (this.val == '2') {
        targetId = this.getUniqueId('0' + index)
      }
      if (this.val == '3' || this.val == '4') {
        targetId = this.getUniqueId('00' + index)
      }
      
      const targetElement = document.getElementById(targetId)
      if (targetElement) {
        // 根据enableImageScale决定添加哪个类
        if (this.enableImageScale) {
          targetElement.classList.add("hoverClass1")
        } else {
          targetElement.classList.add("no-scale-hover")
        }
      }
    }
  },
}
</script>
<style lang="scss">
	.textcontlist{
		font-size: 12px !important;
	}
/*.modelBoxss {
  margin-top: 3rem;
  padding-bottom: 5rem;
  background: url("../../../assets/images/portfolio/model-bg.png") no-repeat;
  background-size: cover;
  .bottom-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .moreBox {
      position: relative;
      transition: all 1s ease;
      margin: 0 1rem;

      .moreBoxImg2 {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        transform: scale(1);
        transition: all 0.5s linear;
      }
      .moreBoxImg3 {
        opacity: 1;
        transition: all 0.5s linear;
      }
      .moreBoxContent {
        position: absolute;
        top: 60%;
        margin: 0 10%;
        transform: translateY(-50%);
        text-align: left;
        transition: all 0.5s ease;
        h5 {
          transition: transform 0.5s ease;
          margin-bottom: 1rem;
        }
        .text {
          transition: all 0.5s ease;
        }
        .btn {
          margin-top: -2rem;
          text-align: center;
          width: 80px;
          opacity: 0;
        }
      }
    }
  }
  .model2 {
    display: flex;
    background: url("../../../assets/images/portfolio/eec/white.png");
    padding: 0;
    .left-img {
      overflow: hidden;
      &:hover {
        img {
          transform: scale(1.1);
        }
      }
      img {
        transition: all 0.5s linear;
      }
    }
    .right-text {
      flex: 1;
      padding: 0 5%;
      margin-top: 10%;
      .text {
      }
    }
  }
}*/
.dislog {
  position: relative;
  z-index: 10;
  display: none;
  width: 100vw;
}

.moveEECPage {
  position: relative;
  z-index: 10;
  display: none;
  width: 100vw;
}
</style>
